/*! @azure/msal-react v3.0.20 2025-09-24 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-react";
const version = "3.0.20";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
